import { Box, Typography, } from "@mui/material";
import ContactForm from "components/Contact/ContactForm";
import PropTypes from "prop-types";
import React from "react";
import Unit from "./Unit.model";
import { getFocus, useGet } from "state/jotai";
import { active_project } from "state/store.global";
import { _project } from "state/store.projects";
import { useLocation } from "react-router-dom";

function SignUpForm({ unit }) {
  const { pin, pid } = useGet(active_project) 
  const buttonsLabel  = getFocus(_project, 'buttonsLabel')?.[pin]?.[pid] ?? []

  const here         = useLocation().pathname
  const atUnit       = here.includes('unit')
  
  const campaignIds = {
    "2": '42217955df3ae26f3505cc4402ee2f98',
    "3": 'fb7f73d3c4b58d42fee62ca7edc227fc',
  }

  return (
    <Box id="unit_page_contact_form" sx={{ pt: {xs: 3, lg: 5}, pb: { md: 5, xs: 0 }, px: { xs: 3, lg: '45px' } }} >
    <Box sx={{  maxWidth: 514, mx: "auto", }} >
      {/* <ContactForm campaignId={campaignIds?.[unit?.data?.Data?.ProjectID?.Value]} drawerType = {'bookViewingDrawer'} grid unit={unit}>
        <Box sx={{ mb: 3 }} >
          <Box className="h3">
           { buttonsLabel?.filter( btn => btn.UILabelProperty ===  "footerHeading1")[0]?.Label || "Ønsker du at booke en fremvisning?"}
          </Box>
          <br />
          <Box className="paragraph1-regular" >
          { buttonsLabel?.filter( btn => btn.UILabelProperty ===  "BookShowingHeading")[0]?.Label || "Udfyld venligst formularen hvis du \u00f8nsker at booke en fremvisning. Du vil blive kontaktet hurtigst muligt." }
          </Box>
        </Box>
      </ContactForm> */}
    </Box>
  </Box>
  );
}

SignUpForm.propTypes = {
  unit: PropTypes.instanceOf(Unit).isRequired,
};

export default SignUpForm;

  // these are some labels you can use when have different forms
  {/* { buttonsLabel?.filter( btn => btn.UILabelProperty === 'SidefodformularUnderoverskrift')[0]?.Label } */}
  {/* Vil du gerne komme først i køen til at modtage nyheder og opdateringer? Udfyld formularen nedenfor for at blive tilføjet til interesselisten */}
  {/* { buttonsLabel?.filter( btn => btn.UILabelProperty === 'SidefodformularOverskrift')[0]?.Label } */}
  {/* Tilmelding til interesselisten */}